module.exports = __webpack_public_path__ + "img/three1Blue.d089672c.png";